/**
 * Initializes the scrollspies on the page.
 *
 * Scrollspies work with columns of buttons, usually in the petrobar. The
 * buttons are linked to sections of the page to easen the navigation.
 * The scrollspy will activate the button corresponding to the section
 * currently displayed on the screen.
 *
 * They are activated by the `js-scrollspy` class.
 *
 * ## Style
 *
 * The buttons of the scrollspy are ghost buttons with md size.
 * They are displayed in column, aligned to the left.
 *
 * ## Example
 *
 *     <div class="has-flex has-flex-col has-items-start js-scrollspy">
 *       <.button color={:ghost} href="#section-1">Section 1</.button>
 *       <.button color={:ghost} href="#section-2">Section 2</.button>
 *       <.button color={:ghost} href="#section-3">Section 3</.button>
 *     </div>
 */
export function init() {
  const scrollSpyEl = document.querySelector(".js-scrollspy");
  if (!scrollSpyEl) return;

  const containerEl = document.querySelector(".app-page__content");
  const scrollSpies = Array.from(document.querySelectorAll(".js-scrollspy")).map((scrollSpyEl) => create(scrollSpyEl, containerEl));

  containerEl.addEventListener(
    "scroll",
    _.debounce(() => {
      for (const scrollSpy of scrollSpies) {
        scrollSpy.update();
      }
    })
  );

  for (const scrollSpy of scrollSpies) {
    scrollSpy.update();
  }
}

function create(scrollSpyEl, containerEl) {
  const buttonsEl = scrollSpyEl.querySelectorAll(".button");
  const targetEls = Array.from(buttonsEl).map((buttonEl) => document.querySelector(buttonEl.getAttribute("href")));

  const isElementActive = (targetEl) => {
    const targetRect = targetEl.getBoundingClientRect();
    const containerRect = containerEl.getBoundingClientRect();
    // The target is only considered active if it at the center of the screen,
    // so that the user is likely currently looking at it.
    // Artbitrarily, we consider that the target is active if it reaches 25% of
    // of the container's height.
    const boundedRect = {
      top: containerRect.top,
      bottom: containerRect.bottom - (containerRect.bottom - containerRect.top) * 0.75,
    };

    return targetRect.bottom >= boundedRect.top && targetRect.top <= boundedRect.bottom;
  };

  const activate = (buttonEl) => {
    const activeClass = "button--active";

    const activeButtonEl = scrollSpyEl.querySelector(`.${activeClass}`);
    activeButtonEl?.classList.remove(activeClass);

    buttonEl.classList.add(activeClass);
  };

  return {
    update() {
      for (let i = buttonsEl.length - 1; i >= 0; i--) {
        const buttonEl = buttonsEl[i];
        const targetEl = targetEls[i];

        if (isElementActive(targetEl)) {
          activate(buttonEl);
          break;
        }
      }
    },
  };
}
